import api from './api';

/**
 * Where a visitor with no session goes.
 *
 * On the demo host (header.vue's exact-match demo gate) the query goes with
 * them. A link from an outreach email or a marketing hub page is
 * `/?tour=sales&region=nashville&utm_campaign=...`, and the login page there
 * reads all three: `tour` opens the demo without a second click, `region`
 * stages the fleet around the visitor's own city. main.js used to redirect to
 * the bare login page, which left a first-time visitor with a button to press
 * and the national fleet (found with the first test emails, 2026-09-20).
 *
 * Everywhere else the login page takes no query, and none is passed.
 */
export default function loginUrl(location = window.location) {
  return location.hostname === 'demo.ladeway.com'
    ? `${api.login}${location.search || ''}`
    : api.login;
}
